import { put } from 'redux-saga/effects';
import AppActions from './AppRedux';
import PropertyActions from './PropertyRedux';
import AdminUserActions from './UsersRedux';
import AuthActions from './AuthRedux';
import API from '@utils/api';
import logger from '@utils/logger';

export function* startup() {
  const authToken = localStorage.getItem('admin_authToken');
  const refreshToken = localStorage.getItem('admin_refreshToken');

  if (refreshToken) {
    try {
      const { result: newAuthToken } = yield API.getAuthToken({
        authToken,
        refreshToken
      });
      yield put(
        AuthActions.setLoggedIn({
          authToken: newAuthToken,
          refreshToken
        })
      );

      yield put(AppActions.setAppDataLoadRequest());
    } catch (err) {
      logger.log('error on refreshing token on reload');
    }
  }

  yield put(AppActions.setLoaded(true));
}

export function* loadAppdata() {
  yield put(AppActions.setLoading(true));

  yield put(AdminUserActions.fetchUsers());

  try {
    const { result } = yield API.fetchGlobalPropertySettings();
    yield put(PropertyActions.setGlobalPropertySettings(result));
  } catch (err) {
    console.log('setGlobalPropertySettings', err);
  }

  let user;

  try {
    const { result } = yield API.getSearchData();
    const { cities, states, regions } = result || {};

    yield put(AppActions.setSearchData(cities, states, regions));
  } catch (err) {
    console.log('getSearchData', err);
  }

  try {
    const { result } = yield API.fetchOffices();
    yield put(AppActions.setAllOffices(result));
  } catch (err) {
    logger.log('error on getting office Info');
  }

  try {
    const { result } = yield API.getUserProfile();
    user = result;
    yield put(AuthActions.setUser(user));
  } catch (err) {
    logger.log('error on getting userInfo');
  }

  yield put(AppActions.setLoading(false));
}
